export default "__VITE_ASSET__CLRa1VlJ__"